import axios from 'axios';
import { ADD_JUNCTURE } from '../../constants';

export const createJuncture = (data, onSuccess, onError) => (dispatch) => {
  const token = localStorage.jwtToken;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  dispatch(addJuncture());
  axios
    .post(`/client/createJuncture`, data, config)
    .then((res) => {
      onSuccess();
      dispatch(setAddJuncture(res));
    })
    .catch((err) => {
      dispatch(errorAddJuncture(err.response));
      onError(err.response);
    });
};

export const addJuncture = () => ({
  type: ADD_JUNCTURE.LOAD,
});

export const setAddJuncture = (data) => ({
  type: ADD_JUNCTURE.SUCCESS,
  payload: data.data,
});

export const errorAddJuncture = (error) => ({
  type: ADD_JUNCTURE.FAIL,
  payload: error,
});
